import React from 'react'
import {ApiQuery, JSONFetcher, ProjectList, ga} from 'shared'

export class ProjectResultsContainer extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      page:         1,
      perPage:      27,
      projects:     [],
      totalEntries: 0,
      totalPages:   0,
      isLoading:    true,
    }
  }

  componentDidMount() {
    this.loadProjects()
  }

  componentDidUpdate(prevProps, prevState) {
    if (this.queryHasChanged(prevProps)) {
      this.setState({projects: []})
      this.loadProjects(1)
    }
  }

  queryHasChanged(prevProps) {
    return prevProps.categoryId != this.props.categoryId ||
           prevProps.bounds     != this.props.bounds ||
           prevProps.searchQuery != this.props.searchQuery
  }

  loadProjects = (page) => {
    this.setState({ isLoading: true })

    let query = new ApiQuery(this.props.apiBaseUrl)
    query.search(this.props.searchQuery).addBounds(this.props.bounds)
         .page(page).per(this.state.perPage).withDefaultFilter()
         .order({
           category_boost: 'desc',
           score: 'desc',
           completed: 'asc',
           rank: 'desc',
           last_donation_at: 'desc'
         })

    query.query.category_id = this.props.categoryId

    JSONFetcher.load({url: query.toUrl(), success: this.projectsLoaded})
  }

  projectsLoaded = (json) => {
    const newProjects = this.state.projects.concat(json.data)
    this.setState({
      projects:        newProjects,
      totalEntries:    json.total_entries,
      totalPages:      json.total_pages,
      page:            json.current_page,
      isLoading:       false,
    })
    this.props.setProjectCount(json.total_entries)
  }

  moreButton() {
    if (this.state.totalPages <= this.state.page) return null

    return <div className='more-button'>
             <a className={'btn btn-primary btn-large' + (this.state.isLoading ? ' is-loading' : '')} href="#" onClick={ this.loadNextPage }>
               <span className='btn-text'>{ I18n.t('discover.categories.index.moar') }</span>
               <span className='btn-icon'></span>
             </a>
           </div>
  }

  loadNextPage = (event) => {
    event.preventDefault()
    ga('send', 'event', 'discover projects: detail', 'show more clicked')
    this.loadProjects(this.state.page + 1)
  }

  render() {
    return <div>
      <ProjectList
        projects={ this.state.projects }
        isLoading={ this.state.isLoading }
        trackingPath='/discover/'
        numberOfPreviews={ this.state.perPage }
        gtmList={ this.props.gtmList }
        openInTab
      />
      { this.moreButton() }
    </div>
  }
}
